import Image from "components/Elements/Image/Image.tsx";
import React from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Icon from "components/Elements/Icon/Icon.tsx";

const FormBuilderTool = ({
  index,
  addNewField,
  element,
  id,
  addItemsToCart,
  formItems,
}) => {
  const { getTextByKey } = useContent();

  const handleDrag = (ev) => {
    ev.dataTransfer.setData("text", ev.target.id);
  };

  return (
    <div
      //draggable
      //onDragStart={(e)=>handleDrag(e)}
      key={id}
      id={id}
      className={`element-line`}
      onClick={() => addNewField(element)}
    >
      <Tooltip id={element.label} tooltipTextKey={element.tooltip} end>
        <div className="element-imageAndName">
          <div className="element-image">
            <Image
              title=""
              alt=""
              name={`create-form/${element.nameImage}`}
              ext="svg"
            />
          </div>
          {/* <span className="space">|</span> */}
          <span
            className="element-label"
            aria-pressed="false"
          >
            {getTextByKey(element.label)}
          </span>
        </div>
        <div className="plus-icon">
          <Icon name="plus" />
        </div>
      </Tooltip>
    </div>
  );
};

export default FormBuilderTool;
